'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=require('./createColorPalette'),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var frost={1:'#f6f8fc',2:'#edf0f5',3:'#dfe4eb',4:'#ced2d9',5:'#888c94',6:'#71747a',7:'#5b5e63',8:'#46494d',9:'#343538',10:'#1c1d1f',inflection:6};exports.default=(0,_createColorPalette2.default)(frost,'frost');


/** WEBPACK FOOTER **
 ** ./~/@vitalsource/vstui/colors/frost.js
 **/